<template>
    <div class="info" v-if="baseInfo != null">
        <div class="row">
            <div class="col-12 col-lg-4 footer-addresses">
                <div v-for="addressLine in addressLines" :key="addressLine.label" class="footer-address-line">
                    <span class="title footer-address-title">{{ addressLine.label }}</span>
                    <span class="text-all">{{ addressLine.value }}</span>
                </div>
            </div>
            <div class="col-12 col-lg-3">
                <!--<span class="title">شماره تماس شرکت: </span> <span class="text-all"> <a :href="'tel:' + baseInfo.TellNo ">{{ baseInfo.TellNo.split('،')[0] }}</a></span>-->
                <!--<br />-->
                <span class="title">شماره تماس فروشگاه: </span> <span class="text-all"> <a :href="'tel:' + baseInfo.TellNo ">{{ baseInfo.TellNo.split('،')[1] }}</a></span>
            </div>
            <div class="col-12 col-lg-3">
                <span class="title">ایمیل: </span><a :href="'mailto:' + baseInfo.Email ">{{ baseInfo.Email }}</a>
            </div>
            <div class="col-12 col-lg-2">
                <div class="socials">
                    <div class="footer-social">
                        <!--<a :href="baseInfo.InstagramLink" :title="' اینستاگرام ' + baseInfo.ShopName" target="_blank"><i class="fa fa-instagram"></i> اینستاگرام</a>-->
                        <a :href="baseInfo.TelegramLink" class="margin" :title="' تلگرام ' + baseInfo.ShopName" target="_blank"><i class="fa fa-telegram"></i> تلگرام</a>
                        <a :href="baseInfo.AparatLink" :title="' واتساپ ' + baseInfo.ShopName" target="_blank"><i class="fa fa-whatsapp"></i> واتساپ</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        computed: {
            baseInfo: function () {
                return this.$store.getters.readBaseInfo;
            },
            addressLines: function () {
                const address = (this.baseInfo.Address || '').trim();
                const storeLabelPattern = /\s*فروشگاه\s*:\s*/;
                const storeLabelMatch = storeLabelPattern.exec(address);

                if (storeLabelMatch === null) {
                    return [{ label: 'آدرس:', value: address }];
                }

                const companyAddress = address.substring(0, storeLabelMatch.index)
                    .replace(/^آدرس\s*:\s*/, '')
                    .trim();
                const storeAddress = address.substring(storeLabelMatch.index + storeLabelMatch[0].length).trim();

                return [
                    { label: 'آدرس شرکت:', value: companyAddress },
                    { label: 'آدرس فروشگاه:', value: storeAddress }
                ].filter(function (addressLine) {
                    return addressLine.value !== '';
                });
            }
        }
    }
</script>

<style scoped>
    .margin {
        margin:0 5px 0 5px;
    }
    .div-image {
        display: inline-block;
    }
    .text-all {
        font-size: 14px;
        font-weight: bold;
    }
    .footer-addresses {
        text-align: right;
    }
    footer.main-footer .info .footer-address-line {
        align-items: baseline;
        display: flex;
        flex-wrap: wrap;
        gap: 4px;
        line-height: 1.8;
        margin-bottom: 3px;
    }
    .footer-address-title {
        white-space: nowrap;
    }
</style>
